//Header on scroll
   //Sticky header
        document.addEventListener("DOMContentLoaded", function () {
            const topBar = document.getElementById("shopify-section-sections--20937953345741__announcement-bar");
            const header = document.getElementById("custom-header");
            const banner = document.getElementById("banner");
            let lastScrollTop = 0;
            window.addEventListener("scroll", function () {
                let scrollTop = window.scrollY || document.documentElement.scrollTop;
                const bannerRect = banner.getBoundingClientRect();
                if (scrollTop > lastScrollTop) {
                    // Scrolling down - hide top bar & move header up
                    topBar.classList.add("hidden");
                    header.style.top = "0"; /* Move header to the very top */
                } else {
                    // Scrolling up - check if banner is visible
                    if (bannerRect.top >= 0) {
                        topBar.classList.remove("hidden");
                        header.style.top = "50px"; /* Restore original position */
                    }
                }
                lastScrollTop = scrollTop;
            });
        });



//Difference Slider
  document.addEventListener("DOMContentLoaded", function () {
    $('.difference-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    document.querySelectorAll(".difference-card").forEach(card => observer.observe(card));
  });


//Start now animation
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.3
    });

    document.querySelectorAll('.fade-in-on-scroll').forEach(el => {
      observer.observe(el);
    });
  });


//Revolution section animation
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.querySelector(".common-pill").classList.add("visible");
          document.querySelector(".revolution-heading").classList.add("visible");
          document.querySelector(".revolution-text").classList.add("visible");
          document.querySelector(".image-grid").classList.add("visible");
        }
      });
    }, {
      threshold: 0.2
    });

    observer.observe(document.querySelector("#revolution-section"));
  });

//faq toggle
function toggleFaq(element) {
  const clickedItem = element.closest('.faq-item');
  const allItems = document.querySelectorAll('.faq-item');

  allItems.forEach(item => {
    if (item !== clickedItem) {
      item.classList.remove('open');
    }
  });

  clickedItem.classList.toggle('open');
}

//faq scroll animation
  document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.animate-on-scroll');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target); // Animate only once
        }
      });
    }, {
      threshold: 0.1
    });

    elements.forEach(el => observer.observe(el));
  });

//Icon text row animation
  document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.animate-on-scroll-sec');

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    elements.forEach(el => observer.observe(el));
  });



//why choose section
document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".card-info, .center-image");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        observer.unobserve(entry.target); // Ensures it only animates once
      }
    });
  }, { threshold: 0.3 }); // Adjust trigger sensitivity

  elements.forEach(el => observer.observe(el));
});

//testimonial slider

  document.addEventListener("DOMContentLoaded", function () {
    $('.testimonial-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    });


// Our process = Scroll animation trigger
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
        }
      });
    }, { threshold: 0.3 });

    const section = document.querySelector('.our-process-section');
    if (section) {
      observer.observe(section);
    }
  });

//Downloadable Designs js
jQuery(document).ready(function($){
    first_child = $(".cat-nav li:first-child").attr('rel');
    $(".holiday-panel ul li:first-child").addClass('active');
    $("#"+ first_child).parent('.right-content').show();

   $(".cat-nav li").each(function(){
        $(this).click(function(){
            var rel = $(this).attr('rel');
            
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            $('.right-content').hide();
            $("#"+rel).parent('.right-content').show();
        });
   });

   $("#top-navigation li").click(function(){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        var rel = $(this).attr('rel');
        console.log(rel);
        $(".free-cat_images ul li").hide();
        if(rel == 'all'){ 
            $(".free-cat_images ul li").show();
        }  else {
            $("."+rel).show();
            
        }
   });
   

   var urlParams = new URLSearchParams(window.location.search);
   cat = urlParams.get('cat');
   console.log(cat);
   if(cat){
    $('.right-content').hide();
    $("#"+cat).parent().siblings('.right-content').hide();
    $("#"+cat).parent('.right-content').show();
    $(".cat-nav li[rel='"+cat+"']").addClass('active');
    $(".cat-nav li[rel='"+cat+"']").siblings().removeClass('active');
   }
});